import type { TimeOffBalance, TimeOffRequest } from '@/client/types/hr';

/** Dates are plain YYYY-MM-DD; format them without a timezone shift. */
export function formatDay(day: string) {
  const [y, m, d] = day.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatRange(r: Pick<TimeOffRequest, 'startDate' | 'endDate'>) {
  return r.startDate === r.endDate ? formatDay(r.startDate) : `${formatDay(r.startDate)} – ${formatDay(r.endDate)}`;
}

export function balanceLabel(b: TimeOffBalance) {
  if (b.allotted === null) return `${b.used} used${b.pending ? `, ${b.pending} pending` : ''} · no cap`;
  return `${b.remaining} of ${b.allotted} left${b.pending ? ` (${b.pending} pending)` : ''}`;
}
